import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  container: {
    [theme.breakpoints.down('sm')]: {
      height: 'calc(100vh - 327px)'
    },
    [theme.breakpoints.up('md')]: {
      height: 'calc(100vh - 226px)'
    },
    backgroundColor: 'white',
    width: '100vw',
    margin: 0
  }
}));
export default useStyles;
